export default __webpack_public_path__ + "static/media/turn-sharp-right.9464fa2f.svg";